// A signed-in login with no vessel, no company, no crew login and no crew profile (src/crew/lib/crewHome.js 'none'):
// one message and Log out - no menu, no dashboard, no data calls.
export default function NoVessel({ onSignOut }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: 'var(--ink)', color: 'var(--text)' }}>
      <div style={{ background: 'var(--hull)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 24, maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 16, fontWeight: 700 }}>No vessel is linked to this login</div>
        <div style={{ color: 'var(--muted)', fontSize: 13, marginTop: 8 }}>If you expected to see a vessel, check your connection and reload, or ask your Captain.</div>
        <button className="btn btn-primary" style={{ marginTop: 18 }} onClick={onSignOut}>Log out</button>
      </div>
    </div>
  )
}
